import { Component } from '@angular/core';

@Component({
  selector: 'app-invalid-url',
  imports: [],
  templateUrl: './invalid-url.component.html',
  styleUrl: './invalid-url.component.scss'
})
export class InvalidUrlComponent {

}
